import { render, staticRenderFns } from "./FirmConfigurableDocuments.vue?vue&type=template&id=32f4e60f"
import script from "./FirmConfigurableDocuments.vue?vue&type=script&lang=js"
export * from "./FirmConfigurableDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports